export const loginAuthMenu = 'login'
export const signupAuthMenu = 'signup'
export const confirmAuthMenu = 'confirm'
export const showResetAuthMenu = 'show-reset'
export const resetAuthMenu = 'reset'

export const translationsAdminMenu = 'translations'
export const translationsNewAdminMenu = 'translations-new'
export const setttingsAdminMenu = 'settings'
export const usersListAdminMenu = 'users'
export const discountsAdminMenu = 'discounts'
export const plansAdminMenu = 'plans'
export const transactionsAdminMenu = 'transactions'
export const feetbackAdminMenu = 'teacher_feetback'
export const support = 'support_questions'

export const  userQuestionsAdmin = 'user-questions'
export const mainOuterSite = "https://qbankmanager.com"

export const routesUrls = {
    'dashboard' : `/`,
    'statistic_reports' : `/statistic_reports`,
    'rooms_students' : `/rooms_students`,
    'students' : `/students`,
    'quizs' : `/quizs`,
    'sliders' : `/sliders`,
    'slider' : `/slider/:id`,
    'trashed' : `/trashed`,
    'card_trashed' : `/card_trashed`,
    'presentations' : `/presentations`,
    'card' : `/cards`,
    'questions_multy' : `/questions_multy`,
    'question_import' : `/question_import`,
    'card_view' : `/cards/view/:id`,
    'question' : `/question/view/:id`,
    'question_multy_view' : `/question_multy/view/:id`,
    'slider_view' : `/slider/view/:id`,
    'quiz' : `/quiz/:id`,
    'presentations_start' : `/presentations_start/:id`,
    'presentation' : `/presentation/:id`,
    'main' : `/`,
    'questions' : `/questions`,

    'auth' : `/auth/:menu`,
    'login' : `/auth/${loginAuthMenu}`,
    'signup' : `/auth/${signupAuthMenu}`,
    'confirm' : `/auth/${confirmAuthMenu}`,
    'reset' : `/auth/${resetAuthMenu}`,
    'showReset' : `/auth/${showResetAuthMenu}`,

    'webLogin' : '/site/login',
    'profile' : `/profile`,
    'payment' : `/payment`,
    'support' : `/support`,
    'transactions' : `/transactions`,
    'referals' : `/referals`,

    'captchaImg' : `/site/captcha`,
    'captchaRefresh' : `/site/captcha?refresh=1`,
    'captchaGetHash' : `/site/captcha?hash=1`,

    'admin' : `/admin/:menu/:submenu?`,
    'student_answer_quiz' : `/student/answer/quiz/:quiz_id/:answer_id`,
    'adminTranslations' : `/admin/${translationsAdminMenu}`,
    'adminTransactions' : `/admin/${transactionsAdminMenu}`,
    'adminTranslationsNew' : `/admin/${translationsNewAdminMenu}`,
    'adminSettings' : `/admin/${setttingsAdminMenu}`,
    'adminUsersList' : `/admin/${usersListAdminMenu}`,
    'adminDiscounts' : `/admin/discounts`,
    'adminTeacherFeetback' : `/admin/${feetbackAdminMenu}`,
    'adminSupportQuestion' : `/admin/${support}`,
    'adminPlans' : `/admin/plans`,
    //'adminUserQuestions' : `/admin/${userQuestionsAdmin}`,


    'notFound' : '/404'
}

export const outerUrls = {
    home : `${mainOuterSite}`,
    about : `${mainOuterSite}/about`,
    contactUs : `${mainOuterSite}/contact-us`,
    faq : `${mainOuterSite}/faq`,
    termsOfUse : `${mainOuterSite}/terms-of-use`,
    privacyPolicy : `${mainOuterSite}/privacy-policy`,

    facebook : `https://www.facebook.com/groups/152770435381477`,
    twitter : `https://twitter.com/QBankManager`,
    youtube : `https://www.youtube.com/channel/UCxrcOyb95aXedaYLayCoUZQ`,
}

const apiPrefix = "/api"

export const ajaxUrls = {
    common : `${apiPrefix}/common/index`,
    commonNonAuthLang : `${apiPrefix}/common/language`,

    questionsList : `/question/list`,

    mcq1Create : `${apiPrefix}/mcq1/create`,
    mcq1Update : `${apiPrefix}/mcq1/update`,
    mcq1Delete : `${apiPrefix}/mcq1/delete`,
    mcq1Upload : `${apiPrefix}/mcq1/upload`,
    mcq1UploadImg : `${apiPrefix}/mcq1/upload-img`,
    mcq1UploadImgDelete : `${apiPrefix}/mcq1/upload-img-delete`,
    mcq1Copy : `${apiPrefix}/mcq1/copy`,
    mcq1Send : `${apiPrefix}/mcq1/send`,
    mcq1QuestionInSubject : `${apiPrefix}/mcq1/questioninsubject`,
    mcq1QuestionInCategory : `${apiPrefix}/mcq1/questionincategory`,
    mcq1QuestionInSubcategory : `${apiPrefix}/mcq1/questioninsubcategory`,
    mcq1StateInCategory : `${apiPrefix}/mcq1/stateincategory`,
    mcq1StateInSubcategory : `${apiPrefix}/mcq1/stateinsubcategory`,

    trashList : `/trash/list`,
    trashRecover : `/trash/recover`,
    trashRemove : `/trash/remove`,
    trashRemoveAll : `/trash/removeall`,

    tempList : `/temp/list`,
    tempSave : `/temp/save`,
    tempRemove : `/temp/remove`,
    tempRemoveAll : `/temp/removeall`,

    qtiImport : `/qti/import`,
    qtiExport : `/qti/export`,

    xlsImport : `/xls/import`,

    pptExport : `/ppt/export`,

    examExport : `${apiPrefix}/export/exam`,

    statisticStatuses : `/statistic/statuses`,

    generalTranslation : `/site/translation`,

    siteLogout : `/site/logout`,

    authLogin : `${apiPrefix}/auth/login`,
    authSignup : `${apiPrefix}/auth/signup`,
    authConfirm : `${apiPrefix}/auth/confirm`,
    authResetPassword : `${apiPrefix}/auth/reset-password`,
    authLogout : `${apiPrefix}/auth/logout`,
    authRequestResetPassword : `${apiPrefix}/auth/request-reset-password`,

    adminDeleteTranslation : `${apiPrefix}/admin/delete-translation`,
    adminCruTranslation : `${apiPrefix}/admin/cru-translation`,
    adminParams : `${apiPrefix}/admin/params`,
    adminUpdateParams : `${apiPrefix}/admin/update-params`,
    profileUserData : `${apiPrefix}/profile/userdata`,
    profileUserUpdate : `${apiPrefix}/profile/userupdate`,
    getUsers : `${apiPrefix}/admin/users-list`,
    setUserStatus: `${apiPrefix}/admin/users-set-status`,
    setUserType: `${apiPrefix}/admin/users-set-type`,

    sourceList : `/source/list`,
    sourceCreate : `/source/create`,
    sourceUpdate : `/source/update`,
    sourceDelete : `/source/delete`,

    categoriesTotal : `/categories/total`,
    categoriesCreate : `/categories/create`,
    categoriesUpdate : `/categories/update`,
    categoriesDelete : `/categories/delete`,
    categoriesFull : `/categories/full`,
    categoriesList : `/categories/list`,

    subcategoriesCreate : `/subcategories/create`,
    subcategoriesUpdate : `/subcategories/update`,
    subcategoriesDelete : `/subcategories/delete`,
    subcategoriesList : `/subcategories/list`,

    subjectList : `/subject/list`,
    subjectListActive : `/subject/list-active`,
    subjectCreate : `/subject/create`,
    subjectUpdate : `/subject/update`,
    subjectDelete : `/subject/delete`,

    feedbackRequest : `/feedback/request`,
    feedbackCreateRequest : `/feedback/createrequest`,

}



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/settings/routes.js